<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"

    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "200px"
    },
    pietitle: {
      type: String,
      default: "总项目工时"
    },
    titlecolor: {
      type: String,
      default: "#444"
    },
    piecolor: {
      type: Array,
      default: () => ["#C8B2F4", "#32DADD"]
    },
    tooltipname:{
      type:String,
      default:"总项目工时"
    },
    legendData: {
      type: Array,
      default: () => ["已结算", "未结算"]
    },
    pieData: {
      type: Array,
      default: () => [
        { value: 320, name: "已结算" },
        { value: 240, name: "未结算" }
      ]
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    pieData: {
      handler(newValue, oldValue) {
        //console.log(newValue);
        this.pieData = newValue; //把新值赋值给我们的属性数据
        this.initChart(); //刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initChart();
    // });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");

      this.chart.setOption({
        color: this.piecolor,
        title: {
          text: this.pietitle,
          x: "left",
          padding: [10, 20],
          textStyle: {
            fontSize: 18,
            fontWeight: "bolder",
            color: this.titlecolor // 主标题文字颜色
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          right: "right",
          bottom: "center",
          padding: [0, 20],
          itemGap: 16,
          data: this.legendData
        },
        series: [
          {
            name: this.tooltipname,
            type: "pie",
            radius: "60%",
            // roseType: 'radius',
            center: ["45%", "50%"],
            data: this.pieData,
            animationEasing: "cubicInOut",
            animationDuration: 2600
          }
        ]
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/KpiTime/PieChart.vue